import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/common/constants/routes';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';
import { Button, Flex } from '@coverflex-tech/hypernova';
import { useRouter } from 'expo-router';

interface IFailedActionProps {
  errorTag: string;
  toggleLearningCentre: (open: boolean) => void;
}

export const FailedAction = ({
  errorTag,
  toggleLearningCentre,
}: IFailedActionProps) => {
  const { t } = useTranslation();
  const router = useRouter();

  let buttonLabel;
  let onClick;

  const handleClickLearnMore = () => {
    router.setParams({ operationId: undefined });
    toggleLearningCentre(true);
  };

  switch (errorTag) {
    case 'wrong_expiration_date':
    case 'error_wrong_pin':
    case 'card_not_active':
      buttonLabel = t('general.manage_card');
      onClick = () => {
        AnalyticsService.trackCustomEvent('manage_card_button_clicked', {
          operation_rejected_reason: errorTag,
          content: 'operation_detail_page',
        });
        router.push(ROUTES.CARD);
      };
      break;
    case 'not_enough_balance':
    case 'exact_match_not_possible':
      buttonLabel = t('general.add_credits');
      onClick = () => {
        AnalyticsService.trackCustomEvent('add_credits_button_clicked', {
          operation_rejected_reason: errorTag,
          content: 'operation_detail_page',
        });
        router.push(ROUTES.CREDITS_ADD);
      };
      break;
    case 'insufficient_funds':
      buttonLabel = t('general.see_balance');
      onClick = () => {
        AnalyticsService.trackCustomEvent('see_balance_button_clicked', {
          operation_rejected_reason: errorTag,
          content: 'operation_detail_page',
        });
        router.push(ROUTES.ROOT);
      };
      break;
    case 'limit_exceeded':
      buttonLabel = t('dashboard.fringe.actions.learn_more');
      onClick = () => {
        AnalyticsService.trackCustomEvent('learn_more_fringe_button_clicked', {
          operation_rejected_reason: errorTag,
          content: 'operation_detail_page',
        });
        handleClickLearnMore();
      };
      break;
    case 'too_many_attempts_wrong_pin':
      buttonLabel = t('general.open_chat');
      onClick = () => {
        AnalyticsService.trackCustomEvent('open_chat_button_clicked', {
          operation_rejected_reason: errorTag,
          content: 'operation_detail_page',
        });
        AnalyticsService.openChat();
      };
      break;
    case 'company_product_not_active':
    case 'mcc_not_in_allowlist':
    case 'mid_in_blocklist':
      buttonLabel = t('general.see_available_benefits');
      onClick = () => {
        AnalyticsService.trackCustomEvent(
          'see_available_benefits_button_clicked',
          {
            operation_rejected_reason: errorTag,
            content: 'operation_detail_page',
          }
        );
        router.push(ROUTES.WELFARE);
      };
      break;
    case 'value_lower_than_min':
    case 'no_vouchers_available':
    case 'max_vouchers_limit_reached':
    case 'company_product_unauthorized':
      buttonLabel = t('dashboard.buoni_pasto.actions.learn_more');
      onClick = () => {
        AnalyticsService.trackCustomEvent(
          'learn_more_buoni_pasto_button_clicked',
          {
            operation_rejected_reason: errorTag,
            content: 'operation_detail_page',
          }
        );
        handleClickLearnMore();
      };
      break;
    default:
      return null;
  }

  return (
    <Flex flexDirection="column" gap="md">
      {errorTag === 'not_enough_balance' && (
        <Button variant="tertiary" onClick={() => handleClickLearnMore()}>
          {t('dashboard.credits.actions.learn_more')}
        </Button>
      )}
      <Button variant="primary" onClick={onClick}>
        {buttonLabel}
      </Button>
    </Flex>
  );
};
